import { AiAuditEventSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * `aiAudit/{eventId}` — append-only ledger of every AI call written by
 * `apps/functions/src/ai/audit.ts`. Super-admin only per firestore.rules
 * (Sprint 72); the `/superadmin/ai` dashboard reads from here to render
 * cost / per-persona / per-tenant / cache-hit breakdowns.
 */
export const aiAuditRepo = createRepo({
  path: 'aiAudit',
  schema: AiAuditEventSchema,
  name: 'aiAudit',
});
